import {
  CustomerStatsData,
  CustomerStatsResponse,
  CustomerCategoryStatsResponse,
  CategoryStatRow,
} from '@/api';
import { AlertType } from '@/models';

const fetchCustomerStats = (
  response: CustomerStatsResponse,
): CustomerStatsData => {
  const { data } = response;

  const stats = {
    na: data.byLevel.na || 0,
    low: data.byLevel.low || 0,
    medium: data.byLevel.medium || 0,
    high: data.byLevel.high || 0,
    severe: data.byLevel.severe || 0,
  };

  const total: number = Object.keys(stats).reduce(
    (temp: number, key: string) => temp + Number(stats[key as AlertType]),
    0,
  );

  return {
    byLevel: stats,
    totals: {
      byLevel: total,
    },
  };
};

const fetchStatsByCategory = (
  response: CustomerCategoryStatsResponse,
): CategoryStatRow[] => {
  const { data } = response;

  const statRows: CategoryStatRow[] = Object.entries(data ?? []).map(
    ([key, value]) => ({
      key,
      entityCategory: value.name,
      totalFunds: value.total / 100,
      receivedFunds: value.income / 100,
      sentFunds: value.outcome / 100,
      totalExpenses: value.expTotal,
      receivedExpenses: value.expIncome,
      sentExpenses: value.expOutcome,
    }),
  );

  return statRows;
};

export { fetchCustomerStats, fetchStatsByCategory };
